import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // Handle ChunkLoadError globally
    if (error?.name === 'ChunkLoadError' || 
        error?.message?.includes('Loading chunk') || 
        error?.message?.includes('ChunkLoadError')) {
      console.warn('ChunkLoadError detected globally, reloading page to clear cache:', error);
      
      // Reload the page to clear cache and retry without reusing tainted input
      // The token is already stored, so reload will maintain authentication
      if (window.location.pathname && window.location.pathname.startsWith('/')) {
        window.location.reload();
      } else {
        window.location.replace('/main/home/dashboard');
      }
      return;
    }
    
    // Log other errors but don't prevent default handling
    console.error('Global error handler:', error);
  }
}
